/* jslint esversion: 6 */
/**
 * Header Fixed
 *
 * @link similar https://codyhouse.co/demo/auto-hiding-navigation/nav-subnav.html
 * @link similar https://www.babble.com/disney/
 *
 * @author Dylan James Wagner
 */
const $ = window.jQuery;
const s = {
	$window            : $(window),
	$header            : $('.header'),
	scrollOffset       : 0,
	windowScrollTop    : 0,
	windowScrollTopPos : 0,
};

function init() {
	s.scrollOffset = s.$header.outerHeight();

	events();
}

function events() {

	s.$window.on('load resize scrollThrottle', function() {

		s.windowScrollTop = s.$window.scrollTop(); // window.pageYOffset;

			s.$header.addClass('header--fixed header--active');

		// if (s.windowScrollTop >= 0) {
		// 	s.$header.addClass('header--fixed header--active');
		// }
		// else {
		// 	/** un-fixed for iOS overflow-scrolling */
		// 	s.$header.removeClass('header--fixed header--active header--inactive');
		// }

		if (s.windowScrollTop >= s.scrollOffset) {

			if (s.$header.hasClass('header--fixed')) {

				if (s.windowScrollTopPos < s.windowScrollTop) {

					if (!(s.$header.filter(':hover').length)) {

						if (s.$header.hasClass('header--active')) {
							s.$header.addClass('header--inactive');
						}

						s.$header.removeClass('header--active');
					}
				}
				else {
					s.$header.addClass('header--active');
					s.$header.removeClass('header--inactive');
				}
			}
		}
		s.windowScrollTopPos = s.$window.scrollTop();
	});

	// $(window).on('load resize scroll',function() {
	// 	const windowWidth = window.innerWidth;
	// 	const headerHeight = $header.height();
	// 	let windowScrollTop = $(window).scrollTop();
	// 	let windowScrollTopPos = $(window).scrollTop();
	//
	// 	if (windowWidth >= s.fixedWidth) {
	// 		// const scrollTop = $(window).scrollTop();
	// 		const pageYOffset = window.pageYOffset;
	//	//
	// 		/** hideaway header--fixed */
	// 			// if (pageYOffset > offset) {
	// 			//
	// 			// 	if (pageYOffset > pos) {
	// 			// 		s.$header.addClass('inactive').removeClass('active');
	// 			//
	// 			// 		// if (s.$header.filter(':hover').length) {
	// 			// 		// 	s.$header.addClass('active').removeClass('inactive');
	// 			// 		// }
	// 			// 	}
	// 			// 	else {
	// 			// 		s.$header.addClass('active').removeClass('inactive');
	// 			// 	}
	// 			// }
	// 			// pos = $(window).scrollTop();
	// 			// pos = window.pageYOffset;
	// 	}
	// });
}

export {init as default};
